import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { AgreementContainer } from './containers/AgreementContainer';
import { trackAgreementOpen } from './tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export var AgreementViewContainer = function AgreementViewContainer() {
  React.useEffect(function () {
    trackAgreementOpen();
  }, []);
  return /*#__PURE__*/_jsx(ViewContainer, {
    children: /*#__PURE__*/_jsx(AgreementContainer, {})
  });
};